
import {TwofishAlgorithm } from './twofish-algorithm';
import { Codecs } from './codecs'

export class Encrypt64 {
  constructor () {
  }

  public static encrypt64(s: string, substring: string): string {

    let retorno: String = "";
    const lastIndex: number = substring.lastIndexOf("46");
    if (lastIndex > 0) {
      substring = substring.substring(0, lastIndex);
    }
    if (substring.length === 32) {
      try {
        let decoder = new TextDecoder('utf8');
        let u8 = new Uint8Array(Codecs.base64Encode(this.encrypt(s.split('').map(s => s.charCodeAt(0)), TwofishAlgorithm.makeKey(this.convertKey(substring)))));
        retorno = decoder.decode(u8);
      } catch (x) {
        console.error("Error: ", x);
      }
    }
    return retorno.toString();
  }

        /*private*/ static convertKey(s: string): number[] {
    const array: number[] = (s => { let a = []; while (s-- > 0) a.push(0); return a; })((s.length / 2 | 0));
    for (let i: number = 0, n: number = 0; i < s.length; i += 2, ++n) {
      {
        array[n] = (<number>(Encrypt64.toHexa(s.charAt(i)) * 16 + Encrypt64.toHexa(s.charAt(i + 1))) | 0);
      };
    }
    return array;
  }

        /*private*/ static toHexa(c: string): number {
    let b: number = 0;
    if ((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) >= '0'.charCodeAt(0) && (c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) <= '9'.charCodeAt(0)) {
      b = (<number>((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) - '0'.charCodeAt(0)) | 0);
    } else if ((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) >= 'a'.charCodeAt(0) && (c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) <= 'f'.charCodeAt(0)) {
      b = (<number>((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) - 'a'.charCodeAt(0) + 10) | 0);
    } else {
      if (!((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) < 'A'.charCodeAt(0) || (c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) > 'F'.charCodeAt(0))) {
        b = (<number>((c => c.charCodeAt == null ? <any>c : c.charCodeAt(0))(c) - 'A'.charCodeAt(0) + 10) | 0);
      }
    }
    return b;
  }

  public static encrypt(array: number[], o: any): number[] {
    let n: number = 0;
    if (array.length % 16 !== 0) {
      n = 16 - array.length % 16;
    }
    const array2: number[] = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(array.length + n);
    const array3: number[] = (s => { let a = []; while (s-- > 0) a.push(0); return a; })(array2.length);
            /* arraycopy */((srcPts, srcOff, dstPts, dstOff, size) => { if (srcPts !== dstPts || dstOff >= srcOff + size) { while (--size >= 0) dstPts[dstOff++] = srcPts[srcOff++]; } else { let tmp = srcPts.slice(srcOff, srcOff + size); for (let i = 0; i < size; i++) dstPts[dstOff++] = tmp[i]; } })(array, 0, array2, 0, array.length);
    for (let i: number = 0; i < n; ++i) {
      {
        array2[array.length + i] = 32;
      };
    }
    let j: number = 0;
    for (const n2: number = (array2.length / 16 | 0); j < n2; ++j) {
      {
        ((srcPts, srcOff, dstPts, dstOff, size) => {
          if (srcPts !== dstPts || dstOff >= srcOff + size) {
            while (--size >= 0)
              dstPts[dstOff++] = srcPts[srcOff++];
          } else {
            let tmp = srcPts.slice(srcOff, srcOff + size);
            for (let i = 0; i < size; i++) dstPts[dstOff++] = tmp[i];
          }
        })
          (TwofishAlgorithm.blockEncrypt(array2, j * 16, o), 0, array3, j * 16, 16);
      };
    }
    return array3;
  }
}
